import { useEffect } from 'react';

export function useBrandingEffect(appLogo: string | null) {
  useEffect(() => {
    if (!appLogo) return;

    // 1. Update Favicon
    let linkIcon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!linkIcon) {
      linkIcon = document.createElement('link');
      linkIcon.rel = 'icon';
      document.head.appendChild(linkIcon);
    }
    linkIcon.href = appLogo;

    // 2. Update Apple Touch Icon
    let linkApple = document.querySelector("link[rel='apple-touch-icon']") as HTMLLinkElement;
    if (!linkApple) {
      linkApple = document.createElement('link');
      linkApple.rel = 'apple-touch-icon';
      document.head.appendChild(linkApple);
    }
    linkApple.href = appLogo;

    // 3. Update Meta OG Image
    let metaOg = document.querySelector("meta[property='og:image']") as HTMLMetaElement;
    if (metaOg) metaOg.content = appLogo;

    // 4. Update Meta Twitter Image
    let metaTwitter = document.querySelector("meta[name='twitter:image']") as HTMLMetaElement;
    if (metaTwitter) metaTwitter.content = appLogo;

    // 5. Dynamic Manifest Update
    const linkManifest = document.querySelector("link[rel='manifest']") as HTMLLinkElement;
    if (linkManifest) {
      const dynamicManifest = {
        "name": "KFPPC - Ping Pong Central",
        "short_name": "KFPPC",
        "start_url": ".",
        "display": "standalone",
        "background_color": "#0f172a",
        "theme_color": "#0033A0",
        "icons": [
          { "src": appLogo, "sizes": "192x192", "type": "image/png" },
          { "src": appLogo, "sizes": "512x512", "type": "image/png" }
        ]
      };
      const blob = new Blob([JSON.stringify(dynamicManifest)], { type: 'application/json' });
      const manifestURL = URL.createObjectURL(blob);
      linkManifest.href = manifestURL;
    }
  }, [appLogo]);
}